import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import InspecaoQualidade from "model/qualidade/InspecaoQualidade";
import ItemPlanoInspecao from "model/qualidade/ItemPlanoInspecao";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import { AutoComplete } from "primereact/autocomplete";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PlanoInspecaoService from "service/qualidade/PlanoInspecaoService";
import "react-hook-form"
import { Controller, useForm } from "react-hook-form";
import { Label } from "components/input/Label";

const planoInspecaoService = new PlanoInspecaoService();

export default function PlanoInspecaoCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, setFocus, register, clearErrors, setError, formState: { errors } } = useForm();

    const inputNomeRef = useRef<any>(null);

    const [planoInspecao, setPlanoInspecao] = useState<PlanoInspecao>(new PlanoInspecao());
    const [titulo, setTitulo] = useState<string>('Plano de inspeção');

    const [inspecoes, setInspecoes] = useState<InspecaoQualidade[]>([]);
    const [inspecoesFiltradas, setInspecoesFiltradas] = useState<InspecaoQualidade[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        planoInspecaoService.getInspecoes().then((data) => {
            setInspecoes(data);
        }).catch((err) => {
            msgErro("erro", err.response.data.message);
        });
    }, [])

    function validar() {

        if (!planoInspecao.codigoInterno) {
            setError("codigoInterno", { type: "manual", message: "Código é Obrigatório" }, { shouldFocus: true })
            return false
        }

        if (!planoInspecao.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (!planoInspecao.fase) {
            setError("fase", { type: "manual", message: "Fase é Obrigatória" }, { shouldFocus: true })
            return false
        }

        return true;
    }

    function validarPersonalizado() {
        for (let i = 0; i < planoInspecao.itens.length; i++) {
            if (!planoInspecao.itens[i].inspecaoQualidade) {
                msgAlerta(`Item ${i + 1}`, "Inspeção não selecionada");
                return false;
            }
            if (planoInspecao.itens[i].valorMinimo > planoInspecao.itens[i].valorMaximo && planoInspecao.itens[i].valorMaximo!=null) {
                msgAlerta(`Valores inválidos no item ${i + 1}`, "O valor mínimo não pode ser maior que o valor máximo");
                return false;
            }
        }
        return true;
    }

    const editorInspecao = (options: ColumnEditorOptions) => {
        return <AutoComplete
            value={options.rowData.inspecaoQualidade}
            placeholder="Selecione um Componente"
            style={{ width: '100%' }}
            field="descricao"
            itemTemplate={(item: InspecaoQualidade) => { return item.codigoInterno ? item.codigoInterno + " - " + item.descricao : item.descricao }}
            suggestions={inspecoesFiltradas}
            completeMethod={(e) => {
                let query = e.query;
                let filtered: InspecaoQualidade[] = [];
                for (let i = 0; i < inspecoes.length; i++) {
                    let inspecao = inspecoes[i];
                    if (inspecao.descricao.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                        filtered.push(inspecao);
                    } else if (inspecao.codigoInterno?.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                        filtered.push(inspecao);
                    } else if ((inspecao.codigoInterno + " - " + inspecao.descricao).toLowerCase().indexOf(query.toLowerCase()) == 0) {
                        filtered.push(inspecao);
                    }
                }
                setInspecoesFiltradas(filtered);
            }}
            onChange={(e) => {
                let planoLocal = JSON.parse(JSON.stringify(planoInspecao));
                if (typeof e.target.value == "string") {
                    let insp = new InspecaoQualidade();
                    insp.descricao = e.target.value;
                    planoLocal.itens[options.rowIndex].inspecaoQualidade = insp;
                } else {
                    planoLocal.itens[options.rowIndex].inspecaoQualidade = e.target.value;
                    planoLocal.itens[options.rowIndex].valorAlvo = e.target.value.valorAlvo;
                    planoLocal.itens[options.rowIndex].valorMinimo = e.target.value.valorMinimo;
                    planoLocal.itens[options.rowIndex].valorMaximo = e.target.value.valorMaximo;
                }
                options.rowData['inspecaoQualidade'] = planoLocal.itens[options.rowIndex].inspecaoQualidade;
                options.rowData.valorAlvo = planoLocal.itens[options.rowIndex].inspecaoQualidade.valorAlvo;
                options.rowData.valorMinimo = planoLocal.itens[options.rowIndex].inspecaoQualidade.valorMinimo;
                options.rowData.valorMaximo = planoLocal.itens[options.rowIndex].inspecaoQualidade.valorMaximo;
                setPlanoInspecao(planoLocal);
            }}

        />
    }

    const editorNumber = (options: any) => {
        return <InputNumber
            value={options.rowData[options.field]}
            minFractionDigits={1}
            maxFractionDigits={6}
            maxLength={16}
            locale="pt-BR"
            onChange={(e) => {
                options.rowData[options.field] = e.value;
                let planoLocal = { ...planoInspecao };
                planoLocal.itens[options.rowIndex] = options.rowData;
                setPlanoInspecao(planoLocal);
            }}
            style={{ width: '100%' }} />;
    }

    const numberTemplate = (rowData: any, options: any) => {
        if (rowData[options.field] == null) {
            return '';
        }
        return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 6 }).format(rowData[options.field]);
    };

    const codigoKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            if (!planoInspecao.codigoInterno) {
                planoInspecaoService.proximoCodigo().then((data) => {
                    setPlanoInspecao({ ...planoInspecao, codigoInterno: data });
                    setFocus("nome")
                    clearErrors("codigoInterno")
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    return (

        <BaseCadastro model={planoInspecao} service={planoInspecaoService} setModel={(value: PlanoInspecao) => setPlanoInspecao(value)}
            validar={() => validar()} validarPersonalizado={() => validarPersonalizado()}
            urlService="/planoInspecao" pathCadastro="/planoInspecao" tituloPagina={'Plano de Inspecao'}
        >

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={planoInspecao.codigoInterno}
                        className={errors.codigoInterno ? "p-invalid" : ""}
                        onKeyDown={codigoKeyDown}
                        style={{ width: '30%' }}
                        {...register("codigoInterno", {
                            onChange: (e) => {
                                clearErrors("codigoInterno")
                                setPlanoInspecao({ ...planoInspecao, codigoInterno: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.codigoInterno && errors.codigoInterno.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigoInterno?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.nome ? "p-invalid" : ""}
                        required value={planoInspecao.nome}
                        style={{ width: '30%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome")
                                setPlanoInspecao({ ...planoInspecao, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Descrição</Label>
                <div className="col-sm-12">
                    <InputText required value={planoInspecao.descricao} onChange={(e) => setPlanoInspecao({ ...planoInspecao, descricao: e.target.value })} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Fase</Label>
                <div className="col-sm-12">
                    <Controller name="fase" control={control} render={({ field }) => (
                        <Dropdown value={planoInspecao.fase}
                            focusInputRef={field.ref}
                            disabled={planoInspecao.id > 0}
                            className={errors.fase ? "p-invalid" : ""}
                            onChange={(e) => {
                                clearErrors("fase")
                                setPlanoInspecao({ ...planoInspecao, fase: e.target.value })
                            }}
                            options={planoInspecaoService.getFases()}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Selecione a fase"
                            style={{ width: '30%' }}
                        />
                    )} />
                </div>
                {errors.fase && errors.fase.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.fase?.message as string}</span> : null}
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Itens"
                        getNewModel={() => new ItemPlanoInspecao()}
                        dataKey="key"
                        lista={planoInspecao.itens ? planoInspecao.itens : []}
                        setLista={(value: any) => setPlanoInspecao({ ...planoInspecao, itens: value })}
                        scrollable
                        scrollHeight='500px'
                        reordable
                        onRowReorder={(e) => {
                            e.value.forEach((item: any, index: number) => {
                                item.sequencial = index + 1;
                            });
                            if (planoInspecao) {
                                planoInspecao.itens = e.value as ItemPlanoInspecao[];
                                setPlanoInspecao({ ...planoInspecao });
                            }

                        }}
                    >
                        <Column rowReorder style={{ width: '3em' }} />
                        <Column field="sequencial" header="Sequencial" style={{ width: '10%' }} />
                        <Column field="inspecaoQualidade.descricao" header="Inspeção" style={{}} editor={editorInspecao} />
                        <Column field="valorAlvo" header="Valor alvo" style={{ width: '10%' }} editor={editorNumber} body={numberTemplate} />
                        <Column field="valorMinimo" header="Valor mínimo" style={{ width: '10%' }} editor={editorNumber} body={numberTemplate} />
                        <Column field="valorMaximo" header="Valor máximo" style={{ width: '10%' }} editor={editorNumber} body={numberTemplate} />
                    </BaseDataTableEdit>
                </div>
            </div>


        </BaseCadastro>
    )
}
